import Record from "slotworks/model/gameplay/records/record";
import { ExpansionResult } from "slotworks/model/gameplay/records/results/expansion-result";
import Result from "slotworks/model/gameplay/records/results/result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { getSymbolImageData, gridDisplay } from "../general-displays/grid-display";

export function expansionResultDisplay(record: Record, result: Result) {
    if (!(record as SpinRecord).grid) {
        return;
    }

    const container = document.createElement("div");
    container.style.width = "10vw";
    container.style.height = "13vh";

    const reelDisplay = gridDisplay(record as SpinRecord);

    const symbols = reelDisplay.querySelectorAll(`[id*=symbol_]`);
    [].forEach.call(symbols, (symbol: HTMLElement) => {
        symbol.style.opacity = ".1";
    });

    const expansionResult = (result as ExpansionResult);

    expansionResult.expansions.forEach((position) => {
        const symbol = reelDisplay.querySelector(`#symbol_${position.x}_${position.y}`) as HTMLElement;
        symbol.style.opacity = "1";
        symbol.style.backgroundImage = "url(" + getSymbolImageData(expansionResult.targetSymbolID) + ")";
    });

    const infoDisplay = document.createElement("div");
    infoDisplay.style.width = "20vw";
    infoDisplay.innerText = `sourceSymbolId: ${expansionResult.sourceSymbolID}`;

    const reelDisplayContainer = document.createElement("div");
    reelDisplayContainer.style.height = "10vh";

    reelDisplayContainer.appendChild(reelDisplay);
    container.appendChild(reelDisplayContainer);
    container.appendChild(infoDisplay);

    return container;
}
